module.exports = __webpack_public_path__ + "static/img/favicon.e3b8d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = ZURh
// module chunks = 1